module.exports = {
   
    API_LOCATION: 'https://ka.iteam.org.ua/apiweb/dev_api.php' 
}